<script>
  import {onMount, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  
  export let slides
  export let useFullWidth = false
  export let style = 'push'
  let slider, st1, st2

  function pinStart () {
    const hh = gsap.getProperty('header', 'height')
    //return 'top top+=' + hh
    return 'top-=' + ( Math.max(0, (window.innerHeight - hh - 690)/2) ) + ' top+=' + hh
  }

  onMount(() => {
    render()
  })

  onDestroy(() => {
    st1?.kill()
    st2?.kill()
  })


  function render () {
    const tl = gsap.timeline({onStart: () => {
      if(!slider) return
      let tallest = 0
      slider.querySelectorAll('.slide').forEach(slide => {
        slide.style.height = ''
        tallest = Math.max(tallest, gsap.getProperty(slide, 'height'))
      })
      slider.querySelectorAll('.slide').forEach(slide => gsap.set(slide, {height: tallest}))
    }})
    let prev;
    switch(style) {
      case 'push' :
        slider.querySelectorAll('.slide').forEach((slide, index) => {
          const time = index * 2 + (index > 1 ? 2 : 0)
          if(index > 0) {
            tl.fromTo(slide.querySelector('picture'), {xPercent: 100}, {xPercent: 0, ease: 'none', duration: 2}, time)
            tl.fromTo(slide.querySelector('.caption .inner'), {xPercent: 20, opacity: 0}, {xPercent: 0, opacity: 1, ease: 'none', duration: 1}, time + 1)
          }
          if(prev) {
            tl.fromTo(prev.querySelector('picture'), {xPercent: 0}, {xPercent: -100, ease: 'none', duration: 2}, time)
            tl.fromTo(prev.querySelector('.caption .inner'), {xPercent: 0, opacity: 1}, {xPercent: -20, opacity: 0, ease: 'none', duration: 1}, time)
          }
          prev = slide
        })
        tl.add(() => {}, '+=2')
        break;
      default : // cover style
        slider.querySelectorAll('.slide').forEach((slide, index) => {
          const time = index * 2 + (index > 1 ? 2 : 0)
          if(index > 0) tl.from(slide, {xPercent: 100, ease: 'sine.inOut', duration: 2}, time)
          if(prev) {
            tl.to(prev.querySelector('.cover'), {opacity: 0.7, ease: 'sine.inOut', duration: 2}, time)
            tl.to(prev, {xPercent: -20, ease: 'sine.inOut', duration: 2}, time)
          }
          prev = slide
        })
        tl.add(() => {}, '+=2')
    }
    st1 = ScrollTrigger.create({
      trigger: slider,
      start: pinStart,
      end: '+=300%',
      scrub: 0.75,
      pin:true,
      anticipatePin: true,
      animation: tl
    })

    const firstSlide = slider.querySelectorAll('.slide')[0],
          firstImage = firstSlide.querySelector('img'),
          firstCaption = firstSlide.querySelectorAll('.caption .anim-item'),
          firstSlideTimeline = gsap.timeline();

    firstSlideTimeline.from(firstImage, {
      opacity: 0,
      scale: 1.5,
      duration: 1,
      ease: 'power2.out'
    }, 0)
    firstSlideTimeline.from(firstCaption, {
      opacity: 0,
      duration: 1,
      ease: 'power2.out',
      stagger: 0.1
    }, 0.2)

    st2 = ScrollTrigger.create({
      trigger: slider,
      start: 'top 70%',
      animation: firstSlideTimeline,
    })
  }

</script>
<div class="slider-outer" bind:this={slider}>
  <div class:content={useFullWidth}>
    <div class="slider style-{style}">
      {#each slides as slide, id (slide)}
      <div class="slide slide{id+1}">
        <div class="image">
          <picture>
            <source srcset={slide.mobileImage} media="(max-width: 767px)" />
            <source srcset={slide.desktopImage} media="(min-width: 768px)" />
            <img src={slide.mobileImage} alt={slide.altText} />
          </picture>
        </div>
        <div class="caption">
          <div class="inner">
            <h1 class="num anim-item">{id+1}</h1>
            <p class="anim-item">{@html slide.caption}</p>
          </div>
        </div>
        <div class="cover"></div>
      </div>
      {/each}  
    </div>
  </div>
</div>

<style>
  .content {
    padding-left: 0;
    padding-right: 0;
  }
  .num {
    font-size: 148px;
    position: absolute;
    margin-top: -16px;
    width: 110px;
    text-align: center;
  }
  .slider {
    overflow: hidden;
    position: inherit;
  }
  .slide {
    display: flex;
    flex-direction: column;
    min-height: 626px;
  }
  .caption {
    background: var(--gray-darkest);
    padding: 40px var(--gutter-sm) 120px;
    flex: 1;
  }
  .slider.style-push {
    background: var(--gray-darkest);
  }
  .slider.style-push .caption {
    background: transparent;
  }
  .caption p {
    margin: 0 0 0 116px;
  }
  .cover {
    position: absolute;
    pointer-events: none;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: black;
    opacity: 0;
  }
  .image,
  picture {
    display: block;
    height: 420px;
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }
  .slide:not(:first-child) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  @media(max-height: 650px) {
    .image,
    picture {
      height: 360px;
    }
    .slide {
      min-height: 566px;
    }
  }
  @media(min-width: 768px) {
    .slide {
      flex-direction: row;
      height: 690px !important;
    }
    .image, picture {
      height: 100%;
    }
    .image, .caption {
      width: 50%;
    }
    .caption {
      padding: 40px calc(var(--gutter-lg) + 8.333vw);
      display: flex;
      align-items: center;
    }
    .caption p {
      margin: 1.5rem 0 0;
    }
    .num {
      margin-top: 0;
      position: relative;
      font-size: 198px;
      width: auto;
      text-align: left;
      line-height: 0.75;
    }
    .slider.style-push .slide:nth-child(1) .caption {
      z-index: 5;
    }
    .slider.style-push .slide:nth-child(2) .caption {
      z-index: 4;
    }
    .slider.style-push .slide:nth-child(2) .caption {
      z-index: 3;
    }
  }
  @media(min-width: 1272px) {
    .caption {
      padding: 40px calc(var(--gutter-lg) + 106px);
    }
  }
</style>